import baseRoute from '../baseRoute';

export default `${baseRoute}/accounting` as const;
